/* eslint-disable */
import { auth } from '@/plugins/auth/firebase.js'
import Cookie from 'js-cookie'
import JWTDecode from 'jwt-decode'

export const providers = {
    namespaced: true,
    state: {
        provider_list: [],
        currentItem: {},
        isLoading: false,
    },

    mutations: {

        SET_PROVIDER_LIST(state, payload) {
            state.provider_list = payload
        },
        SET_LOADING(state, payload) {
            state.isLoading = payload
        },
        SET_CURRENT_ITEM(state, payload) {
            state.currentItem = payload
        },
    },

    actions: {
        async loadItems({ commit, state, rootState, dispatch }, type) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true)
                let userId = ''
                if (rootState.users.user.adminUid) {
                    userId = rootState.users.user.adminUid
                } else {
                    userId = rootState.users.user.uid
                }
                // console.log(userId)
                let path
                let loadCommit

                switch (type) {
                    case 'providers':
                        path = `users/${userId}/providers`
                        loadCommit = 'SET_PROVIDER_LIST'
                        break
                }

                // console.log(path)
                firebase.database().ref(path).orderByChild('name').on('value',
                    function (data) {
                        if (data.val()) {
                            let items = Object.values(data.val()) || [];
                            // console.log(items)
                            commit(loadCommit, items)
                            commit('SET_LOADING', false)
                            resolve()
                        } else {
                            commit(loadCommit, [])
                            commit('SET_LOADING', false)
                            resolve()
                        }
                    }, function (error) {
                        console.error(error)
                        commit('SET_LOADING', false)
                        dispatch('users/showErrorSessionExpired', null, {root:true})
                        reject()
                    },
                )
            })
        },
        setCurrentItem({ commit, state, rootState }, payload) {
            // commit('SET_LOADING', true);
            const vm = this
            let userId = ''
            if (rootState.users.user.adminUid) {
                userId = rootState.users.user.adminUid
            } else {
                userId = rootState.users.user.uid
            }
            if (payload) {
                return new Promise((resolve, reject) => {
                    const path = `users/${userId}/providers`
                    const setCommit = 'SET_CURRENT_ITEM'
                    let id

                    try {
                        const currentItem = state.provider_list.find(item => item.id === payload.id)
                        // console.log(currentItem)
                        if (!payload.id) {
                            id = currentItem.id
                        } else {
                            id = payload.id
                        }
                        const dbRef = firebase.database().ref()
                        let item
                        dbRef.child(path + '/' + id).on('value', function (data) {
                            // console.log(data.val(), id)
                            item = {
                                ...data.val(),
                                id: data.key,
                            }
                            commit(setCommit, item)
                            // commit('setLoading', false);
                            resolve()
                        }, function (error) {
                            // console.log(error)
                            // commit('setLoading', false);
                            reject()
                        })
                    } catch (err) {
                        reject()
                        // console.log(err)
                    }
                })
            } else {
                commit('SET_CURRENT_ITEM', {})
            }
        },
        deleteItem({ commit, state, rootState, getters }, payload) {
            return new Promise((resolve, reject) => {
                let userId = ''
                if (rootState.users.user.adminUid) {
                    userId = rootState.users.user.adminUid
                } else {
                    userId = rootState.users.user.uid
                }
                const id = payload.id
                commit('SET_LOADING', true)
                const promises = []
                // console.log(`providers/pictures/${id}`)
                promises.push(firebase.database().ref().child(`users/${userId}/providers/${id}`).remove())
                // console.log(payload.pictures.imageInput1)
                if (payload.pictures.imageInput1) {
                    promises.push(firebase.storage().ref(`users/${userId}/providers/pictures/${id}`).child('imageInput1').delete())
                }
                Promise.all(promises).then(function () {
                    // commit('setWriting', false);
                    resolve()
                }, function (error) {
                    commit('SET_LOADING', false)
                    // console.log(error)
                    reject()
                })
            })
        },
        providerLoading({ commit }) {
            commit('SET_LOADING', true)
        },
        async createItem({ commit, state, rootState }, payload) {
            commit('SET_LOADING', true)
            let userId = ''
            if (rootState.users.user.adminUid) {
                userId = rootState.users.user.adminUid
            } else {
                userId = rootState.users.user.uid
            }

            const key = payload.id ? payload.id : firebase.database().ref().child(`users/${userId}/providers`).push().key
            const itemData = {
                ...payload,
                id: key,
                created: firebase.database.ServerValue.TIMESTAMP,
            }
            const updates = {}
            updates[`users/${userId}/providers/${key}`] = itemData
            await firebase.database().ref().update(updates).then(function () {
                // created!
                commit('SET_LOADING', false)
            })
        },
        async updateItem({ commit, state, rootState }, payload) {
            commit('SET_LOADING', true)
            const vm = this

            let userId = ''
            if (rootState.users.user.adminUid) {
                userId = rootState.users.user.adminUid
            } else {
                userId = rootState.users.user.uid
            }
            const itemData = payload
            await firebase.database().ref(`users/${userId}/providers/${itemData.id}`).update(itemData).then(function () {
                // updated!
                commit('SET_LOADING', false)
            },
            ).catch(function (err) {
                commit('SET_LOADING', false)
                throw err
            })
        },

    },
    getters: {
        getItems(state) {
            return state.provider_list
        },
        getCurrentItem(state) {
            return state.currentItem
        },
        isLoading(state) {
            return state.isLoading
        }
    },

}
